

export interface deviceParameterProps {
	//waves: string[];
	parms: string[];
}

export const deviceParameters: { [id: string]: deviceParameterProps } = {
	"Recobro v2": {
		parms: ["HR", "Resp", "SpO2", "IBP1", "IBP2", "NIBP", "Temp"],
	},

	"TEGO": { 
        parms: ["HR", "SpO2", "Temp", "Resp"] 
    },

	"Defigard Touch 7": {
		parms: ["HR", "Resp", "SpO2", "IBP1", "NIBP", "Temp"],
	},

    "APLC3": {
		parms: ["HR", "Resp", "SpO2", "IBP1", "IBP2", "IBP3", "IBP4", "NIBP", "Temp"],
	},
};
